import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from './Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const navigate = useNavigate();
  return <section className="relative bg-white pt-20 pb-32 overflow-hidden" data-id="element-65">
      {/* Background Mountain Landscape */}
      <div className="absolute inset-x-0 bottom-0 pointer-events-none z-0" data-id="element-66">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 0.12
      }} transition={{
        duration: 1.5,
        delay: 0.2
      }} className="w-full h-full" data-id="element-67">
          <svg viewBox="0 0 1440 400" preserveAspectRatio="none" className="w-full h-[300px] md:h-[400px] object-cover object-bottom" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-68">
            {/* Gold Sun Arc (like the logo) */}
            <path d="M 420 220 A 320 320 0 0 1 1020 220" stroke="#B8963E" strokeWidth="5" strokeLinecap="round" opacity="0.6" data-id="element-69" />
            {/* Sun glow */}
            <path d="M 500 230 A 240 240 0 0 1 940 230" stroke="#B8963E" strokeWidth="2" strokeLinecap="round" opacity="0.3" data-id="element-70" />

            {/* Farthest Mountains (Lightest) */}
            <path d="M 0 300 L 150 180 L 280 260 L 450 120 L 600 240 L 780 100 L 950 220 L 1150 140 L 1300 250 L 1440 160 L 1440 400 L 0 400 Z" fill="#8BA4C7" opacity="0.5" data-id="element-71" />
            {/* Snow - farthest peaks (organic curves following slopes) */}
            <path d="M 450 120 Q 430 140 415 155 Q 445 148 470 155 Q 465 138 450 120 Z" fill="white" opacity="0.55" data-id="element-72" />
            <path d="M 780 100 Q 758 125 742 140 Q 775 132 808 140 Q 798 120 780 100 Z" fill="white" opacity="0.55" data-id="element-73" />
            <path d="M 1150 140 Q 1132 158 1118 172 Q 1148 165 1175 172 Q 1168 155 1150 140 Z" fill="white" opacity="0.45" data-id="element-74" />

            {/* Mid Mountains */}
            <path d="M 0 350 L 200 220 L 350 310 L 550 180 L 700 280 L 880 160 L 1050 290 L 1250 190 L 1440 280 L 1440 400 L 0 400 Z" fill="#3D5A80" opacity="0.6" data-id="element-75" />
            {/* Snow - mid peaks */}
            <path d="M 550 180 Q 530 200 518 212 Q 548 205 575 212 Q 568 195 550 180 Z" fill="white" opacity="0.5" data-id="element-76" />
            <path d="M 880 160 Q 858 182 845 195 Q 878 188 908 195 Q 900 178 880 160 Z" fill="white" opacity="0.5" data-id="element-77" />

            {/* Front Mountains (Darkest) */}
            <path d="M 0 400 L 100 280 L 250 360 L 400 240 L 580 340 L 750 210 L 900 320 L 1100 230 L 1350 350 L 1440 300 L 1440 400 L 0 400 Z" fill="#1B2A4A" opacity="0.85" data-id="element-78" />
            {/* Snow - front peaks */}
            <path d="M 750 210 Q 728 235 715 248 Q 748 240 778 248 Q 770 230 750 210 Z" fill="white" opacity="0.4" data-id="element-79" />
            <path d="M 1100 230 Q 1080 252 1068 264 Q 1098 257 1125 264 Q 1118 248 1100 230 Z" fill="white" opacity="0.35" data-id="element-80" />

            {/* Base ground */}
            <rect x="0" y="390" width="1440" height="20" fill="#1B2A4A" opacity="0.85" data-id="element-81" />
          </svg>
        </motion.div>
      </div>

      {/* Foreground Content (centered) */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-82">
        <div className="text-center max-w-3xl mx-auto" data-id="element-83">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-5xl md:text-6xl font-extrabold text-navy tracking-tight mb-6" data-id="element-84">
            Your Trusted Moving Partner in{' '}
            <span className="text-gold" data-id="element-85">Utah</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-xl text-gray-600 mb-10" data-id="element-86">
            Honest pricing, careful handling, and friendly service. That's the
            Justice Moving difference. Proudly serving Salt Lake and Utah
            counties.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-87">
            <Button onClick={() => navigate('/quote')} variant="primary" className="w-full sm:w-auto text-lg px-8 py-4" data-id="element-88">
              Get Your Free Quote
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-89" />
            </Button>
            <div className="text-sm text-gray-500 font-medium" data-id="element-90">
              No obligation. Fast response.
            </div>
          </motion.div>
        </div>
      </div>

      {/* Subtle color blurs */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-full h-full overflow-hidden -z-10 pointer-events-none opacity-5" data-id="element-91">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[60%] rounded-full bg-navy blur-3xl" data-id="element-92" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[60%] rounded-full bg-gold blur-3xl" data-id="element-93" />
      </div>
    </section>;
}